import React from 'react'
import { NavLink } from 'react-router-dom'

const CardBlog = (props) => {
    return (
        <div className="wrapper__card-blog mb-4">
            <img src={props.data.bg} alt="" className="cover mb-3" />
            <div className="desc">
                <div className="tag normal font__size--14 text__14-1024">{props.data.tag}</div>
                <h4 className="semi-bold font__size--20 text__20-1024">{props.data.title}</h4>
                {/* <NavLink to="/blog/detail" className="d-inline-block color__orange">
                    <div className="d-flex align-items-center">
                        <span className="medium font__size--16 text__16-1024 mr-2">Read More</span>
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_217_4732)">
                                <path d="M1.20211 9.00198C1.28395 8.9887 1.36676 8.98257 1.44963 8.98365H15.5592L15.2516 8.84055C14.9508 8.69821 14.6772 8.50449 14.4431 8.26815L10.4864 4.31147C9.96527 3.81402 9.87771 3.01378 10.2789 2.41541C10.7458 1.77777 11.6412 1.63932 12.2789 2.10622C12.3304 2.14397 12.3793 2.18511 12.4254 2.22938L19.5803 9.38433C20.1395 9.94286 20.14 10.8489 19.5814 11.4081C19.5811 11.4084 19.5807 11.4088 19.5803 11.4092L12.4254 18.5641C11.8658 19.1222 10.9597 19.1209 10.4016 18.5613C10.3577 18.5173 10.3167 18.4704 10.2789 18.421C9.87771 17.8226 9.96527 17.0224 10.4864 16.525L14.4359 12.5611C14.6459 12.3509 14.8872 12.1747 15.1514 12.0388L15.5807 11.8456H1.52838C0.797363 11.8728 0.156012 11.3621 0.0186806 10.6436C-0.107826 9.86348 0.421997 9.12854 1.20211 9.00198Z" fill="#F48148" />
                            </g>
                            <defs>
                                <clipPath id="clip0_217_4732">
                                    <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0.405762)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </NavLink> */}

                {/* <div className="profile">
                    <img src={props.data.profile} alt="" />
                    <div className="desc ml-2">
                        <h5 className="semi-bold font__size--12 mb-0">By {props.data.name}</h5>
                        <p className="mb-0 normal font__size--10 color__gray-1">{props.data.date}</p>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default CardBlog